export default __webpack_public_path__ + "static/media/3.9aba6978.jpg";